import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Spinner } from "reactstrap";
import CryptoJS from 'crypto-js';

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword, clearErrorMessage } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/Logo-with.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
// Add this import
import { useTranslation } from "react-i18next";

const ForgetPasswordPage = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  async function getClientIp() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;  
    } catch (error) {
      console.error('Failed to get IP:', error);
      return null;
    }
  }


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email(t("Invalid email format")).required(t("Email is required")),
    }),
   onSubmit: async (values) => {
    const email = values.email;
    const ipAddress = await getClientIp(); 
    const userAgent = navigator.userAgent;

    const payload = {
      email,
      ipAddress,
      userAgent,
      createdAt: new Date().toISOString(),
      expiresAt: new Date(Date.now() + 15 * 60 * 1000).toISOString(), // expires in 15 min
      used: false,
    };

    const secretKey = "FORGETPASS"; 
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(payload), secretKey).toString();
    
    const resetURL = `${window.location.origin}/reset-password/${encodeURIComponent(encryptedData)}`;

    dispatch(userForgetPassword({ Email: values.email, URL: resetURL }));
  }

  });


  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
      loading: state.loading,
    })
  );

  // Inside your component
  const {
    forgetError, forgetSuccessMsg, loading
  } = useSelector(selectLayoutProperties);

  useEffect(() => {
    // Clear any existing messages when the component loads
    dispatch(clearErrorMessage());
  }, [dispatch]);

  document.title = "Reset Password | Alitqan";
  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5">

        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                     <img src={logoLight} alt="" height="50" />
                  </Link>
                </div>
                {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">

                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">{t("Forgot Password?")}</h5>
                    <p className="text-muted">{t("Reset password with Alitqan")}</p>

                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#0ab39c"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    >
                    </lord-icon>

                  </div>

                  <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    {t("Enter your email and instructions will be sent to you!")}
                  </Alert>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {t(forgetError)}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {t(forgetSuccessMsg)}
                      </Alert>
                    ) : null}
                    <Form
                      dir={i18n.language === "ar" ? "rtl" : "ltr"}
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">{t("Email")}</Label>
                        <Input
                          name="email"
                          dir={i18n.language === "ar" ? "rtl" : "ltr"}
                          className={`form-control`}
                          placeholder={t("Enter email")}
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn btn-success w-100" type="submit" disabled={loading}>
                          {loading ? (
                            <Spinner size="sm" className="me-2 ms-2">
                              {" "}
                              Loading...{" "}
                            </Spinner>
                          ) : null}
                          {t("Send Reset Link")}
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">{t("Wait, I remember my password...")} <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> {t("Click here")} </Link> </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
